import { createAction, props } from '@ngrx/store';
import { CommunityProduct } from '../../models/community-product.model';


export const loadFilteredCommunityProducts = createAction(
  '[Product] Load Filtered Community Products',
  props<{ categoryId?: string; subRegionId?: any; basedProduct?: any, search?: any }>()
);
export const loadFilteredCommunityProductsSuccess = createAction(
  '[Product] Load Filtered Community Products Success',
  props<{ filteredProducts: CommunityProduct[] }>()
);
export const loadFilteredCommunityProductsFailure = createAction(
  '[Product] Load Filtered Community Products Failure',
  props<{ error: any }>()
);
